import {
  enhanceBrxFacets,
  refineBrxFacetsArgs,
} from "~/helpers/internal/";
export default {
  extractFacetLabels(facetsObj) {
    return enhanceBrxFacets(facetsObj.items);
  },
  refineFacetArgs(facetsObj) {
    return refineBrxFacetsArgs(facetsObj.items);
  },
};
